import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { API_URL } from "../../../helpers/app_url";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  CardHeader,

} from "reactstrap"
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import EligibilitypagesMenu from "../menu/eligibilitypages-menu";
import LeadEligibilityBreadcrumb from "components/Common/LeadEligibilityBreadcrumb";
import SaveButton from "components/buttons/save";
import axios from "axios";
import img1 from "../../../assets/img/doc-1.png"
import img2 from "../../../assets/img/doc-2.png"
import img3 from "../../../assets/img/doc-3.png"
import SafeField from "helpers/SafeField";
class ReasonEligibility extends Component {
  constructor(props) {
    super(props)
    this.state = {

      isRight: false,
      questions: ""
    }

  }
  componentDidMount() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    if (!obj || !obj.resultData) return;  // Ensure authUser and resultData exist

    const token = obj.resultData.bearerToken;
    const userId = localStorage.getItem("userId");
    if (!userId) return;  // Ensure userId exists

    const str = "Bearer " + token;

    axios
      .get(API_URL + `QualificationQuestion/allagentQualificationSpecificQuestionAnswers?agentId=${userId}&question=Reason`, {
        headers: { Authorization: str },
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
          const questions = res.data[0];

          if (questions && questions.answers) {
            // Helper function to safely find the answer and its scoringValue
            const findScoringValue = (answer) => {
              const foundAnswer = questions.answers.find((a) => a.answer === answer);
              return foundAnswer ? foundAnswer.scoringValue : null;  // Return null if answer is not found
            };

            // Setting the state with the questions and answer scoring values
            this.setState({
              questions: {
                id: questions.id,
                qualificationQuestionId: questions.qualificationQuestionId,
                weightage: questions.weightage,
                answers: questions.answers,
                quest1: findScoringValue("First time buyer"),
                quest2: findScoringValue("Moving up"),
                quest3: findScoringValue("Downsizing"),
                quest4: findScoringValue("Investment"),
                quest5: findScoringValue("Retiring"),
                quest6: findScoringValue("Other"),
              },
            });
          }
        } else {
          console.warn("No questions found.");
        }
      })
      .catch((error) => {
        console.error("Error fetching questions:", error);
      });
  }
 handleSubmit = (values, { setSubmitting }) => {
  const { questions } = this.state;
  const agentId = parseInt(localStorage.getItem("userId"));

  const getAnswerId = (answerText) => {
    const found = questions?.answers?.find((a) => a.answer === answerText);
    return found ? found.id : 0;
  };

  const submissionData = {
    createQualificationBulkQuestionWithAnswersList: [
      {
        id: questions?.id || 0,
        agentId,
        weightage: parseInt(values.weightage),
        question: "Reason",
        primaryScoringValue: 0,
        secondaryScoringValue: 0,
        otherScoringValue: 0,
        isActive: true,
        questionAnswers: [
          {
            id: getAnswerId("First time buyer"),
            agentId,
            questionId: questions?.id || 0,
            answer: "First time buyer",
            scoringType: 0,
            scoringValue: parseInt(values.quest1),
            isActive: true,
          },
          {
            id: getAnswerId("Moving up"),
            agentId,
            questionId:questions?.id || 0,
            answer: "Moving up",
            scoringType: 0,
            scoringValue: parseInt(values.quest2),
            isActive: true,
          },
          {
            id: getAnswerId("Downsizing"),
            agentId,
            questionId: questions?.id || 0,
            answer: "Downsizing",
            scoringType: 0,
            scoringValue: parseInt(values.quest3),
            isActive: true,
          },
          {
            id: getAnswerId("Investment"),
            agentId,
            questionId: questions?.id || 0,
            answer: "Investment",
            scoringType: 0,
            scoringValue: parseInt(values.quest4),
            isActive: true,
          },
          {
            id: getAnswerId("Retiring"),
            agentId,
            questionId: questions?.id || 0,
            answer: "Retiring",
            scoringType: 0,
            scoringValue: parseInt(values.quest5),
            isActive: true,
          },
          {
            id: getAnswerId("Other"),
            agentId,
            questionId: questions?.id || 0,
            answer: "Other",
            scoringType: 0,
            scoringValue: parseInt(values.quest6),
            isActive: true,
          }
        ],
      },
    ],
  };

  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj.resultData.bearerToken;
  const str = "Bearer " + token;

  toast.loading("Please wait...");
  axios.post(API_URL + `QualificationQuestion/AddUpdateQualificationBulkQuestionAnswers`, submissionData, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': str
    }
  })
    .then(response => {
      toast.dismiss();
      if (response.data.success === true) {
        toast.success("Saved successfully");
      } else {
        toast.error("Some error occurred");
      }
    })
    .catch(error => {
      toast.dismiss();
      console.error('Error submitting form:', error);
    })
    .finally(() => {
      setSubmitting(false);
    });
};

  render() {

    return (
      <React.Fragment>

        <ToastContainer autoClose={2000} />

        <div className="page-content project-page-content">
          <MetaTags>
            <title>Eligibility Questions | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0 pe-0">


            <Row className="mb20 project-header">
              <Col xl="6">
                <LeadEligibilityBreadcrumb
                  title={this.props.t("Lead")}

                  breadcrumbItem={this.props.t("Eligibility Questions")}
                />

              </Col>

            </Row>
            <Row>


              <Col xl="12">

                <Card>
                  <CardBody>
                    <EligibilitypagesMenu />
                    <Row className="align-items-stretch">
                      <Col sm="5">
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            weightage: this.state.questions.weightage || "",
                            quest1: this.state.questions.quest1 || "",
                            quest2: this.state.questions.quest2 || "",
                            quest3: this.state.questions.quest3 || "",
                            quest4: this.state.questions.quest4 || "",
                            quest5: this.state.questions.quest5 || "",
                            quest6: this.state.questions.quest6 || "",
                          }}
                          validationSchema={Yup.object().shape({
                            weightage: Yup.number().required("This is required").typeError("Enter valid number"),
                            quest1: Yup.number().required("This is required").typeError("Enter valid number"),
                            quest2: Yup.number().required("This is required").typeError("Enter valid number"),
                            quest3: Yup.number().required("This is required").typeError("Enter valid number"),
                            quest4: Yup.number().required("This is required").typeError("Enter valid number"),
                            quest5: Yup.number().required("This is required").typeError("Enter valid number"),
                            quest6: Yup.number().required("This is required").typeError("Enter valid number"),

                          })}

                          onSubmit={this.handleSubmit}
                        >
                          {({ errors, touched, values, handleChange, setFieldValue }) => (
                            <Form
                              className="needs-validation"
                            >

                              <Card className="border-brk mt-40">
                                <CardHeader>
                                  <CardTitle>Step 1 : How important is the Reason to move in the overall eligibility score.</CardTitle>

                                  <Row>

                                    <Col sm="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="weightage"
                                          className={
                                            "form-control" +
                                            (errors.weightage && touched.weightage ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="weightage"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="10">

                                      (Assign a numerical value (1-100) to indicate how important “Decision stage” of the buyer in your overall lead evaluation. A higher value means higher importance.)

                                    </Col>
                                  </Row>
                                </CardHeader>
                              </Card>

                              <Card className="border-brk mt-40">
                                <CardHeader>
                                  <CardTitle>Step 2 : Assign scores for different reasons</CardTitle>
                                  <p>(Assign a numerical value (1-100) to indicate how important “Decision stage” of the buyer in your overall lead evaluation. A higher value means higher importance.)</p>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="quest1">
                                          {this.props.t("First time buyer")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="quest1"
                                          className={
                                            "form-control" +
                                            (errors.quest1 && touched.quest1 ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="quest1"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="quest2">
                                          {this.props.t("Moving up")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="quest2"
                                          className={
                                            "form-control" +
                                            (errors.quest2 && touched.quest2 ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="quest2"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="quest3">
                                          {this.props.t("Downsizing")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="quest3"
                                          className={
                                            "form-control" +
                                            (errors.quest3 && touched.quest3 ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="quest3"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="quest4">
                                          {this.props.t("Investment")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="quest4"
                                          className={
                                            "form-control" +
                                            (errors.quest4 && touched.quest4 ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="quest4"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="quest5">
                                          {this.props.t("Retiring")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="quest5"
                                          className={
                                            "form-control" +
                                            (errors.quest5 && touched.quest5 ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="quest5"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <Row>
                                    <Col md="3">
                                      <FormGroup className="mb-3">
                                        <Label htmlFor="quest6">
                                          {this.props.t("Other")}
                                        </Label>

                                      </FormGroup>
                                    </Col>
                                    <Col md="2">
                                      <FormGroup className="mb-3">

                                        <SafeField
                                          name="quest6"
                                          className={
                                            "form-control" +
                                            (errors.quest6 && touched.quest6 ? " is-invalid" : "")
                                          }
                                          onChange={handleChange}
                                          type="text"
                                        />

                                        <ErrorMessage
                                          name="quest6"
                                          component="div"
                                          className="invalid-feedback"
                                        />
                                      </FormGroup>
                                    </Col>
                                    <Col sm="1"></Col>

                                  </Row>
                                  <SaveButton>Save</SaveButton>
                                </CardHeader>
                              </Card>

                            </Form>
                          )}
                        </Formik>
                      </Col>

                      <Col sm="1" className="d-flex align-items-stretch justify-content-center">
                        <div className="vertical-line"></div>
                      </Col>

                      <Col sm="6">
                        <div className="link-page">

                          <div className="open-bg">
                            <h4><img src={img3} width="32px" /> Purpose</h4>
                                 <ul className="no-list-type">
                              <li>Understanding why someone is looking to buy helps you evaluate how committed they are and what kind of follow-up approach makes sense. Whether they’re upsizing, investing, relocating, or just browsing — their motivation plays a key role in how likely they are to move forward. </li>

                               <li><strong>Step 1:</strong><br/>
                             Decide how important the lead’s reason for buying is in your qualification process. If buyer intent is a big indicator for you, give this a higher importance setting. 
                               
                               </li>

                                <li><strong>Step 2:</strong><br/>
                              Assign points to each reason based on how motivated or serious you think that type of lead usually is. Give more points to reasons you believe indicate a higher likelihood of conversion. 

                               <br/>
                               <strong>For example:</strong> You may consider someone relocating for work more urgent than someone casually browsing the market. 
                             
                               </li>
                            </ul>
                          </div>
                        </div>
                      </Col>
                    </Row>

                  </CardBody>
                </Card>




              </Col>

            </Row>



          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ReasonEligibility.propTypes = {
  t: PropTypes.any,



}
const mapStateToProps = ({ }) => (
  {



  })
const mapDispatchToProps = dispatch => ({



});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReasonEligibility))
